import { Diagnostic, IoCContainer, ISettings, IUtils, WebCoreIoCKeys } from 'web-core-src';
import { ISettingsStorage } from './settings-storage.interface';

export abstract class SettingsStorageBase implements ISettingsStorage {
    //replaced by the webpack build
    public static VERSION: string = '@version';

    public static V_VERSION_SNAKE_CASE: string = 'v0_0_99';

    private debugModeForSettingStorage: boolean = false;
    private appSettings: ISettings;

    protected abstract getSettingsFromStorage(): Promise<any>;
    protected abstract setSettingsToStorage(settings: any): Promise<void>;
    protected abstract backupSettingsToStorage(settings: any, backupName: string): Promise<void>;

    public async resetAllModuleSettingsWithDefaultValues(): Promise<void> {
        Diagnostic.debug('SettingsStorageBase - resetAllModuleSettingsWithDefaultValues started');

        this.appSettings.setDefaultValues();

        await this.updateSettingsInStorage();
        Diagnostic.debug('SettingsStorageBase - resetAllModuleSettingsWithDefaultValues ended');
        this.translateDefaultValues();
    }

    public async updateSettingsInStorage(): Promise<void> {
        Diagnostic.debug('SettingsStorageBase - updateSettingsInStorage started');
        this.DebuggerDebug('SettingsStorageBase - updateSettingsInStorage - setSettingsToStorage started');
        await this.setSettingsToStorage(this.appSettings);
        Diagnostic.debug('SettingsStorageBase - updateSettingsInStorage ended');

        return Promise.resolve();
    }

    public async createPreImportBackup(): Promise<void> {
        let now: Date = new Date();
        let nowString: string = now.toJSON().substring(0, 19).replaceAll('-', '_').replaceAll(':', '_').replaceAll('T', '__');
        await this.backupSettingsToStorage(this.appSettings, 'settings_pre_import_backup_' + nowString);
    }

    public initSettingsStorage(appSettings: ISettings, coreSettings: ISettings): void {
        appSettings.settingsStorage = this;
        appSettings.version = SettingsStorageBase.VERSION;
        coreSettings.settingsStorage = this;

        this.appSettings = appSettings;
        this.appSettings['core'] = coreSettings;
    }

    public async initSettings(appSettings: ISettings, coreSettings: ISettings): Promise<void> {
        this.initSettingsStorage(appSettings, coreSettings);

        let settings = await this.getSettingsFromStorage();
        this.loadSettings(settings);

        return Promise.resolve();
    }

    private translateDefaultValues(): void {
        this.DebuggerDebug('SettingsStorageBase - translateDefaultValues started');
        this.appSettings.translateDefaultValues();
        this.DebuggerDebug('SettingsStorageBase - translateDefaultValues ended');
    }

    public setAppSettings(settingsJsonString: string): void {
        let settingsJson = this.settingsJsonParse(settingsJsonString);
        this.loadSettings(settingsJson);
    }

    public getAppSettings(): ISettings {
        return this.appSettings;
    }

    private loadSettings(settings: any): void {
        let utils: IUtils = IoCContainer.get(WebCoreIoCKeys.IUtils);
        utils.deepCopy(this.appSettings, settings);

        this.appSettings.settingsStorage = this;
        this.appSettings['core'].settingsStorage = this;
    }

    protected settingsJsonParse(settingsJsonString: string): any {
        return JSON.parse(settingsJsonString, this.jsonPropertyReviver);
    }

    public async loadSettingsFromStorage(): Promise<void> {
        this.DebuggerDebug('SettingsStorageBase - loadSettingsFromStorage started');
        let settingsJson = await this.getSettingsFromStorage();

        this.DebuggerDebug('SettingsStorageBase - loadSettingsFromStorage - getSettingsFromStorage - result', settingsJson);

        this.loadSettings(settingsJson);

        this.DebuggerDebug('SettingsStorageBase - loadSettingsFromStorage ended');
        return Promise.resolve();
    }

    public getCurrentSettingsJSON(): string {
        return this.getSettingsJSON(this.appSettings);
    }

    protected getSettingsJSON(settings: any): string {
        return JSON.stringify(settings, this.jsonPropertyReplace);
    }

    protected jsonPropertyReplace(propertyName: string, value: any): any {
        if (propertyName == 'settingsStorage') {
            return undefined;
        }
        // if (value instanceof Date) {
        //     return '¤¤¤-' + value.getTime() + '-' + value.toJSON();
        // }

        return value;
    }

    protected jsonPropertyReviver(propertyName, value): Date {
        let reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
        let reMsAjax = /^\/Date\((d|-|.*)\)[\/|\\]$/;
        if (typeof value === 'string') {
            var a = reISO.exec(value);
            if (a) {
                return new Date(value);
            }
            a = reMsAjax.exec(value);
            if (a) {
                var b = a[1].split(/[-+,.]/);
                return new Date(b[0] ? +b[0] : 0 - +b[1]);
            }
        }
        return value;
    }

    protected DebuggerDebug(text: string, ...optionalParams: any[]): void {
        if (this.debugModeForSettingStorage) {
            Diagnostic.debug(text, optionalParams);
        }
    }
}

export class SettingEvents {
    public static SETTING_CHANGED: string = 'SettingChanged';
}
